import { render, staticRenderFns } from "./LegendaCompreende.vue?vue&type=template&id=2060ec78&scoped=true&"
import script from "./LegendaCompreende.vue?vue&type=script&lang=js&"
export * from "./LegendaCompreende.vue?vue&type=script&lang=js&"
import style0 from "./LegendaCompreende.vue?vue&type=style&index=0&id=2060ec78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060ec78",
  null
  
)

export default component.exports